import { swalAttention } from './swal';

export function validarForm(
  form: Record<string, any>,
  camposObrigatorios: Record<string, string>,
): boolean {
  const errors: string[] = [];

  for (const campo in camposObrigatorios) {
    const label = camposObrigatorios[campo];

    if (!form[campo]) {
      errors.push(`<b>${label}</b> é obrigatório.`);
    }
  }

  if (errors.length > 0) {
    swalAttention(errors.join('<br>'));
    return false;
  }

  return true;
}
